// The compact layout, on one screen.
//
// A match with a wheel: the board, the tray, and the cue bar. The cue bar is
// last, so the roll button is under the right thumb. The wheel is a row
// between the board and the tray. It shows only at a roll, and `compact.css`
// hides it the rest of the time. Every other part is in a tray panel.
//
// Godsmode has no tray. The parts are in the order of the board: the top
// bar, the line of Moon, the board, then the dock: the sheet of Sun and the
// cue. Two seats each hold more than one part, and `caster.css` shows one of
// them. The seat over the board has the line of Moon, and the inspector
// while a piece is picked. The seat under the board has the sheet of Sun and
// the held card until its last pick. The open log, or the pane of a caster
// the player reads, covers the whole dock. Changed 2026-10-13. The log had
// the seat of Sun only, which is 85px on a short phone, and no line showed.
// The board stays, because a press on a log line shows that step on it.

import { createTray } from '../components/Tray';
import { el } from '../lib/dom';
import { COMPACT_TRAY_TABS } from '../state/tray';
import type { LayoutParts, MountLayout } from './parts';

export const createCompactLayout = (parts: LayoutParts): MountLayout => {
  const tray = createTray(COMPACT_TRAY_TABS);
  const moonSeat = el('div', { className: 'seat seat--moon' });
  const sunSeat = el('div', { className: 'seat seat--sun' });
  const logSheet = el('section', { className: 'log-sheet' });
  const dock = el('div', { className: 'dock' });

  return (app, mode) => {
    if (mode === 'gods') {
      logSheet.replaceChildren(parts.historyNav, parts.logBox, parts.graveyard);
      moonSeat.replaceChildren(parts.moonTeam, parts.inspector);
      sunSeat.replaceChildren(parts.sunTeam, parts.hand);
      dock.replaceChildren(sunSeat, parts.cueBar, logSheet, parts.casterRead);
      app.replaceChildren(parts.topBar, moonSeat, parts.boardFrame, dock);
      return;
    }
    tray.panels.spell.replaceChildren(parts.hand);
    tray.panels.piece.replaceChildren(parts.inspector, parts.graveyard, parts.energyRow);
    tray.panels.log.replaceChildren(parts.historyNav, parts.logBox);
    tray.panels.match.replaceChildren(parts.topBar);
    app.replaceChildren(parts.boardFrame, parts.wheelBox, tray.root, parts.cueBar);
  };
};
